import createCache, { type Options } from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { ThemeProvider } from "@mui/material/styles";
import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { Router } from "wouter";
import App from "./App";
import "./index.css";
import { merged } from "./theme/styles";

const key = Math.random()
  .toFixed(6)
  .split(".")[1]
  .split("")
  .map((intString) => String.fromCharCode(97 + parseInt(intString)))
  .join("");
const cache = createCache({ key } as Options);

hydrateRoot(
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  document.getElementById("root")!,
  <StrictMode>
    <Router>
      <CacheProvider value={cache}>
        <ThemeProvider theme={merged}>
          <App />
        </ThemeProvider>
      </CacheProvider>
    </Router>
  </StrictMode>
);
